<template>
  <el-row :gutter="20">
    <div class="name" style="padding: 10px">
      <span class="demonstration">年份</span>
      <el-date-picker
        value-format="yyyy"
        v-model="value1"
        type="year"
        placeholder="选择年"
        :picker-options="pickerOptions0"
        @change="handleQuery"
      >
      </el-date-picker>
      <!-- <el-button type="primary" icon="el-icon-search" size="medium" @click="handleQuery">确认
      </el-button> -->
    </div>
    <el-col :span="8">
      <el-card class="box-card_totle">
        <div class="top">
          <div class="left"></div>
        </div>
        <div
          class="echart"
          id="projectHourYear"
          :style="myChartStyle"
          v-if="hourYearData.length > 0"
        ></div>
        <el-empty v-if="hourYearData.length == 0"></el-empty>
      </el-card>
    </el-col>
    <el-col :span="8">
      <el-card class="box-card_totle">
        <div class="top">
          <div class="left"></div>
        </div>
        <div
          class="echart"
          id="projectConsumeYear"
          :style="myChartStyle"
          v-if="consumeYearData.length > 0"
        ></div>
        <el-empty v-if="consumeYearData.length == 0"></el-empty>
      </el-card>
    </el-col>
    <el-col :span="8">
      <el-card class="box-card_totle">
        <div class="top">
          <div class="left"></div>
        </div>
        <div
          class="echart"
          id="jobConsumeYear"
          :style="myChartStyle"
          v-if="jobYearData.length > 0"
        ></div>
        <el-empty v-if="jobYearData.length == 0"></el-empty>
      </el-card>
    </el-col>
    <div class="top" style="padding: 10px; display: flex">
      <div class="left">
        <div class="name">
          <div class="block">
            <span class="demonstration">月份</span>
            <el-date-picker
              value-format="yyyy-MM"
              v-model="value2"
              type="month"
              placeholder="选择月"
              @change="handleQueryDate"
              :picker-options="pickerOptions0"
            >
            </el-date-picker>
            <!-- <el-button type="primary" icon="el-icon-search" size="medium" @click="handleQueryDate">确认
            </el-button> -->
          </div>
        </div>
      </div>
    </div>
    <el-col :span="8">
      <el-card class="box-card_totle">
        <div class="top">
          <div class="left"></div>
        </div>
        <div
          class="echart"
          id="projectHourMonth"
          :style="myChartStyle"
          v-if="hourMonthData.length > 0"
        ></div>
        <el-empty v-if="hourMonthData.length == 0"></el-empty>
      </el-card>
    </el-col>
    <el-col :span="8">
      <el-card class="box-card_totle">
        <div class="top">
          <div class="left"></div>
        </div>
        <div
          class="echart"
          id="projectConsumeMonth"
          :style="myChartStyle"
          v-if="consumeMonthData.length > 0"
        ></div>
        <el-empty v-if="consumeMonthData.length == 0"></el-empty>
      </el-card>
    </el-col>
    <el-col :span="8">
      <el-card class="box-card_totle">
        <div class="top">
          <div class="left"></div>
        </div>
        <div
          class="echart"
          id="jobConsumeMonth"
          :style="myChartStyle"
          v-if="jobMonthData.length > 0"
        ></div>
        <el-empty v-if="jobMonthData.length == 0"></el-empty>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
import * as echarts from "echarts";
import { set } from "vue";

export default {
  data() {
    return {
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      value1: "",
      value2: "",
      hourYearData: [],
      hourMonthData: [],
      consumeYearData: [],
      consumeMonthData: [],
      jobYearData: [],
      jobMonthData: [],
      myChartStyle: { float: "left", width: "100%", height: "400px" }, //图表样式
    };
  },

  mounted() {
    var date = new Date();
    var year = date.getFullYear().toString();
    var month =
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1;
    var toMonth = year + "-" + month;
    this.value1 = year;
    this.value2 = toMonth;
    this.initDate();
    this.initDateMouth();
  },
  methods: {
    initDate(e) {
      let p1 = new Promise((resolve, reject) => {
        httpKit
          .post($api_pms.home.projectHourMonth, { month: e || this.value1 })
          .then((res) => {
            // this.refreshing = false;
            console.log(res);
            if (res.data.code === "200") {
              console.log("ok");
              if (res.data.data.length > 0) {
                this.hourYearData = res.data.data;
                console.log(this.hourYearData);
                resolve(this.hourYearData);
              }
            }
          });
      });
      let p2 = new Promise((resolve, reject) => {
        httpKit
          .post($api_pms.home.projectConsumeMonth, { month: e || this.value1 })
          .then((res) => {
            // this.refreshing = false;
            console.log(res);
            if (res.data.code === "200") {
              console.log("ok");
              if (res.data.data.length > 0) {
                this.consumeYearData = res.data.data;
                console.log(this.consumeYearData);
                resolve(this.consumeYearData);
              }
            }
          });
      });
      let p3 = new Promise((resolve, reject) => {
        httpKit
          .post($api_pms.home.jobConsumeMonth, { month: e || this.value1 })
          .then((res) => {
            console.log(res);
            if (res.data.code === "200") {
              console.log("ok");
              this.jobYearData = res.data.data;
              console.log(this.jobYearData);
              resolve(this.jobYearData);
            }
          });
      });
      Promise.all([p1, p2, p3])
        .then((result) => {
          this.initEcharts();
        })
        .catch((error) => {
          console.log(111111111, error);
        });
    },
    initDateMouth(e) {
      let p1 = new Promise((resolve, reject) => {
        httpKit
          .post($api_pms.home.projectHourMonth, { month: e || this.value2 })
          .then((res) => {
            // this.refreshing = false;
            console.log(res);
            if (res.data.code === "200") {
              console.log("ok");
              if (res.data.data.length > 0) {
                this.hourMonthData = res.data.data;
                console.log(this.hourMonthData);
                resolve();
              }
            }
          });
      });
      let p2 = new Promise((resolve, reject) => {
        httpKit
          .post($api_pms.home.projectConsumeMonth, { month: e || this.value2 })
          .then((res) => {
            // this.refreshing = false;
            console.log(res);
            if (res.data.code === "200") {
              console.log("ok");
              if (res.data.data.length > 0) {
                this.consumeMonthData = res.data.data;
                console.log(this.consumeMonthData);
                resolve();
              }
            }
          });
      });
      let p3 = new Promise((resolve, reject) => {
        httpKit
          .post($api_pms.home.jobConsumeMonth, { month: e || this.value2 })
          .then((res) => {
            console.log(res);
            if (res.data.code === "200") {
              console.log("ok");
              if (res.data.data.length > 0) {
                this.jobMonthData = res.data.data;
                console.log(this.jobMonthData);
                resolve();
              }
            }
          });
      });
      Promise.all([p1, p2, p3])
        .then((result) => {
          this.initEcharts1();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleQuery(e) {
      this.hourYearData = [];
      this.consumeYearData = [];
      this.jobYearData = [];
      this.initDate(e);
    },
    handleQueryDate(e) {
      this.hourMonthData = [];
      this.consumeMonthData = [];
      this.jobMonthData = [];
      this.initDateMouth(e);
    },
    initEcharts() {
      // this.$nextTick(() => {
      var myEvent = new Event("resize"); // 创建一个支持冒泡且不能被取消的resize事件
      window.dispatchEvent(myEvent); // 事件可以在任何元素触发
      // });
      // 饼图
      const optionHourYear = {
        series: [
          {
            type: "pie",
            label: {
              show: true,
              formatter: "{b}\n\t{c} ({d}%)", // b代表名称，c代表对应值，d代表百分比
            },
            radius: "60%", //饼图半径
            data: this.hourYearData,
          },
        ],
        title: {
          text: "按年统计项目工时消耗",
          left: "center",
        },
      };
      const optionConsumeYear = {
        series: [
          {
            type: "pie",
            label: {
              show: true,
              formatter: "{b}\n\t{c}元 ({d}%)", // b代表名称，c代表对应值，d代表百分比
            },
            radius: "60%", //饼图半径
            data: this.consumeYearData,
          },
        ],
        title: {
          text: "按年统计项目成本消耗",
          left: "center",
        },
      };
      const optionJobYear = {
        series: [
          {
            type: "pie",
            label: {
              show: true,
              formatter: "{b}\n\t{c}元({d}%)", // b代表名称，c代表对应值，d代表百分比
            },
            radius: "60%", //饼图半径
            data: this.jobYearData,
          },
        ],
        title: {
          text: "按年岗位成本消耗",
          left: "center",
        },
      };

      this.projectHourYear = echarts.init(
        document.getElementById("projectHourYear")
      );
      this.projectHourYear.clear();
      this.projectHourYear.setOption(optionHourYear);
      this.projectConsumeYear = echarts.init(
        document.getElementById("projectConsumeYear")
      );
      this.projectConsumeYear.clear();
      this.projectConsumeYear.setOption(optionConsumeYear);
      this.jobConsumeYear = echarts.init(
        document.getElementById("jobConsumeYear")
      );
      this.jobConsumeYear.clear();
      this.jobConsumeYear.setOption(optionJobYear);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.projectHourYear.resize();
        this.projectConsumeYear.resize();
        this.jobConsumeYear.resize();
      });
    },
    initEcharts1() {
      // this.$nextTick(() => {
      var myEvent = new Event("resize"); // 创建一个支持冒泡且不能被取消的resize事件
      window.dispatchEvent(myEvent); // 事件可以在任何元素触发
      // });
      // 饼图
      const optionHourMonth = {
        series: [
          {
            type: "pie",
            label: {
              show: true,
              formatter: "{b}\n\t{c} ({d}%)", // b代表名称，c代表对应值，d代表百分比
            },
            radius: "60%", //饼图半径
            data: this.hourMonthData,
          },
        ],
        title: {
          text: "按月份项目工时消耗",
          left: "center",
        },
      };
      const optionConsumeMonth = {
        series: [
          {
            type: "pie",
            label: {
              show: true,
              formatter: "{b}\n\t{c} ({d}%)", // b代表名称，c代表对应值，d代表百分比
            },
            radius: "60%", //饼图半径
            data: this.consumeMonthData,
          },
        ],
        title: {
          text: "按月份项目成本消耗",
          left: "center",
        },
      };
      const optionJobMonth = {
        series: [
          {
            type: "pie",
            label: {
              show: true,
              formatter: "{b}\n\t{c} ({d}%)", // b代表名称，c代表对应值，d代表百分比
            },
            radius: "60%", //饼图半径
            data: this.jobMonthData,
          },
        ],
        title: {
          text: "按月份岗位成本消耗",
          left: "center",
        },
      };

      this.projectHourMonth = echarts.init(
        document.getElementById("projectHourMonth")
      );
      this.projectHourMonth.clear();
      this.projectHourMonth.setOption(optionHourMonth);

      this.projectConsumeMonth = echarts.init(
        document.getElementById("projectConsumeMonth")
      );
      this.projectConsumeMonth.clear();
      this.projectConsumeMonth.setOption(optionConsumeMonth);

      this.jobConsumeMonth = echarts.init(
        document.getElementById("jobConsumeMonth")
      );
      this.jobConsumeMonth.clear();
      this.jobConsumeMonth.setOption(optionJobMonth);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.projectHourMonth.resize();

        this.projectConsumeMonth.resize();

        this.jobConsumeMonth.resize();
      });
    },
  },
};
</script>
